module.exports = __webpack_public_path__ + "img/05_bg.8d5b2f81.png";